export default {
    namespaced: true,
    state: {
        sound: window.localStorage.getItem("settings.sound") != "false",
        difficulty: parseInt(window.localStorage.getItem("settings.difficulty")) || 2
    },
    actions: {
        setSound({ state, commit }, sound) {
            commit("set", { ...state, sound });
        },
        setDifficulty({ state, commit }, difficulty) {
            commit("set", { ...state, difficulty });
        }
    },
    mutations: {
        set(state, settings) {
            state.sound = settings.sound;
            state.difficulty = settings.difficulty;
            window.localStorage.setItem("settings.sound", state.sound);
            window.localStorage.setItem("settings.difficulty", state.difficulty);
        }
    }
};
